import { createI18n } from 'vue-i18n';
import en from '@/i18n/locales/en';
import fa from '@/i18n/locales/fa';

const messages = {
  en,
  fa,
};

const i18n = createI18n({
  legacy: false,
  locale: 'fa',
  globalInjection: true,
  messages,
});

export default i18n;
